var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.55888 9.6158L0.336803 2.39372C0.228761 2.2858 0.143036 2.15763 0.0845574 2.01656C0.0260785 1.87549 -0.00402832 1.72429 -0.00402832 1.57158C-0.00402832 1.41887 0.0260785 1.26766 0.0845574 1.12659C0.143036 0.98552 0.228761 0.857349 0.336803 0.749427C0.444725 0.641384 0.572879 0.555678 0.713948 0.497199C0.855018 0.43872 1.00622 0.408613 1.15893 0.408613C1.31164 0.408613 1.46285 0.43872 1.60392 0.497199C1.74499 0.555678 1.87318 0.641384 1.9811 0.749427L8.79064 7.55898L16.0127 0.336908C16.1206 0.228865 16.2488 0.143158 16.3899 0.0846794C16.5309 0.0262006 16.6822 -0.00390625 16.8349 -0.00390625C16.9876 -0.00390625 17.1388 0.0262006 17.2799 0.0846794C17.4209 0.143158 17.5491 0.228865 17.657 0.336908C17.7651 0.44483 17.8507 0.572983 17.9092 0.714053C17.9677 0.855122 17.9978 1.00635 17.9978 1.15906C17.9978 1.31177 17.9677 1.46297 17.9092 1.60404C17.8507 1.74511 17.7651 1.87326 17.657 1.98119L10.0224 9.6158C9.69557 9.94222 9.25255 10.1256 8.79064 10.1256C8.32872 10.1256 7.8857 9.94222 7.55888 9.6158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10.1272,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhite);
export default __webpack_public_path__ + "static/media/downArrowWhite.c1da5086c2cb4b898a3487e7727be8ca.svg";
export { ForwardRef as ReactComponent };